import jwtInterceptor from '/src/shared/jwtInterceptor'

const apiUrl = process.env.VUE_APP_API_URL + process.env.VUE_APP_API_PATH;

const actions = {
  async getAllWarehouses()
  {
    const url = apiUrl + 'warehouseProduct/ListAjax';
    const response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data.warehouses
    }
  },
  async getWarehouse(c,id)
  {
    const url = apiUrl + 'warehouse/get?id='+id;
    const response = await jwtInterceptor.post(url);
    if (response && response.data)
    {
      return response.data
    }
  },
  async addProductToWarehouse(c,data)
  {
    const url = apiUrl + 'WarehouseProduct/addIn';
    const response = await jwtInterceptor.post(url,data);
    if (response && response.data)
    {
      return response.data
    }
  },
  async getInvoice(c,id)
  {
    const url = apiUrl + 'WarehouseInvoice/getInfo/'+id;
    const response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data
    }
    return null;
  },
  async getWpInfoForChangePrice(c,id)
  {
    const url = apiUrl + 'warehouseProduct/getProductInfo/'+id;
    const response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data
    }
    return null;
  }

};

export default {
  namespaced: true,
  actions
}